import { useEffect, useState } from 'react';

export const useMetaData = () => {
    const [metaData, setMetaData] = useState<{
        description: string | null | undefined;
        title: string;
    }>({
        description: '',
        title: '',
    });

    useEffect(() => {
        if (typeof document !== 'undefined') {
            const { title } = document;
            const description = document
                .querySelector('meta[name="description"]')
                ?.getAttribute('content');

            setMetaData({ title, description });
        }
    }, []);

    return metaData;
};
